import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { ListingSortComponentDef } from '@df/catalog-ui/listing/sort/listing-sort.component.def';

@Component({
    selector: 'listing-sort',
    templateUrl: './listing-sort.html',
    styleUrls: ['./listing-sort.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingSortComponent extends ListingSortComponentDef {
    private changeDetectorRef = inject(ChangeDetectorRef);

    @Input()
    openByDefault = false;

    toggleState = false;

    protected toggle(): void {
        this.toggleState = !this.toggleState;
        this.changeDetectorRef.detectChanges();
    }
}
